angular.module('env.data.repos.groups', [])

    .service("groupsRepository", function (rest) {
        var _this = this;

        /**
         * Get permissions by user group name
         * @param {string} userGroupName user group name
         * @returns {!Promise.<Object[]>} promise of permissions collection
         */
        _this.getPermissionsByGroupName = function (userGroupName) {
            return rest.map("groups").map(userGroupName).map("permissions").get();
        };

        return _this;
    })

;